import { useEffect, useRef, useState } from "react";
import { BsBell } from "react-icons/bs";
import "./notification.scss";
import WebService from "../../Services/WebService";
import { toast } from "react-toastify";
import HelperService from "../../Services/HelperService";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";

interface Notification {
  id: string;
  title: string;
  message: string;
  is_read: boolean;
  created_at: string;
}

interface PropsData {
  count: number;
}

const NotificationBell = ({ count }: PropsData) => {
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const ref = useRef<HTMLDivElement>(null);

  const bodyRef = useRef<HTMLDivElement>(null);

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [fetchingMore, setFetchingMore] = useState(false);
  let navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [notCount, setNoteCount] = useState(0);

  const [modalMessage, setModalMessage] = useState("");
  const [subscriptionMode, setSubscriptionMode] = useState("");
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    setNoteCount(count);
  }, [count]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const getNotificationList = (pageNumber: number, isLoadMore = false) => {
    if (!hasMore && isLoadMore) return;

    if (isLoadMore) {
      setFetchingMore(true);
    } else {
      setLoader(true);
    }

    return WebService.getAPI({
      action: `fcm-notifications?offset=${pageNumber - 1}`,
      body: null,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          const newList = res?.list || [];

          if (isLoadMore) {
            setNotifications((prev) => [...prev, ...newList]);
          } else {
            setNotifications(newList);
          }

          // 👇 Important: check if more data available
          if (res?.next_offset === -1) {
            setHasMore(false);
          } else {
            setHasMore(true);
          }
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
      })
      .finally(() => {
        setLoader(false);
        setFetchingMore(false);
      });
  };

  const handleMarkRead = (notification: any) => {
    return WebService.putAPI({
      action: `fcm-notifications/${notification?.id}`,
      body: null,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          setNoteCount(res?.unread_count);
        }
        if (notification?.meta) {
          if (notification?.meta?.type === "ENTREPRENEUR") {
            navigate("/manage-entrepreneur", {
              state: { sub_type: notification?.meta?.sub_type },
            });
          } else if (notification?.meta?.type === "INVESTOR") {
            navigate("/manage-investor");
          }
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const handleReadAll = () => {
    return WebService.postAPI({
      action: `fcm-notifications/read/all`,
      body: null,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          setNoteCount(0);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        WebService.removeLoader("read_all");
      });
  };

  // const handleDeleteNotification = (notification_id: string) => {
  //   WebService.addLoader(`delete_${notification_id}`);
  //   return WebService.CommonApi({
  //     method: "DELETE",
  //     action: `notification/${notification_id}`,
  //     body: null,
  //   })
  //     .then((res: any) => {
  //       if (res?.status) {
  //         setNoteCount(res?.unread_count);
  //         getNotificationList(page);
  //       }
  //     })
  //     .catch((error: any) => {
  //       toast.error(error?.response?.data?.message);
  //       return error;
  //     })
  //     .finally(() => {
  //       WebService.removeLoader(`delete_${notification_id}`);
  //     });
  // };

  useEffect(() => {
    if (!open) return;

    const container = bodyRef.current;
    if (!container) return;

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = container;

      if (scrollTop + clientHeight >= scrollHeight - 10) {
        if (!fetchingMore && hasMore) {
          const nextPage = page + 1;

          console.log("🔥 calling next page:", nextPage);

          setPage(nextPage);
          getNotificationList(nextPage, true);
        }
      }
    };

    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [open, page, hasMore, fetchingMore]);
  return (
    <>
      <div
        className="notification-wrapper me-3"
        ref={ref}
        onClick={() => getNotificationList(page)}
      >
        <div
          className="bell"
          onClick={() => {
            setOpen(!open);
            setPage(1);
            setHasMore(true);
            getNotificationList(1, false);
          }}
        >
          <BsBell size={24} />
          {notCount > 0 && (
            <span className="badge1">{notCount > 10 ? "10+" : notCount}</span>
          )}
        </div>

        {open && (
          <div className="notification-dropdown">
            <div className="notification-header justify-content-end border-bottom-0">
              {notifications.length > 0 && notCount > 0 && (
                <button
                  id="read_all"
                  className="read-all-btn"
                  onClick={handleReadAll}
                >
                  Read all
                </button>
              )}
            </div>

            {/* 📜 Content */}
            <div className="notification-body" ref={bodyRef}>
              {loader ? (
                <div className="notification-loader">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="skeleton-item">
                      <div className="skeleton-title" />
                      <div className="skeleton-line" />
                    </div>
                  ))}
                </div>
              ) : notifications.length === 0 ? (
                <p className="empty">No notifications</p>
              ) : (
                notifications.map((n: any) => (
                  <div
                    key={n.id}
                    className={`notification-item ${!n.is_read ? "unread" : ""}`}
                    onClick={() => {
                      if (n?.is_read === 0) handleMarkRead(n);
                      else {
                        if (n?.meta?.type === "ENTREPRENEUR") {
                          navigate("/manage-entrepreneur");
                        } else if (n?.meta?.type === "INVESTOR") {
                          navigate("/manage-investor");
                        }
                      }

                      // handleNavigation(
                      //   n?.id,
                      //   n?.action,
                      //   n?.action_id,
                      // );
                    }}
                  >
                    <div className="notification-content">
                      <h6>{n?.notification?.title}</h6>

                      <p>
                        {n?.description
                          ? n.description.length > 50
                            ? n.description.slice(0, 50) + "..."
                            : n.description
                          : ""}
                      </p>

                      <span>
                        {n.created_at
                          ? HelperService.getFormatedDateByDMYTime(
                              n?.created_at,
                            )
                          : null}
                      </span>
                    </div>

                    {/* 🗑️ Delete icon */}
                    {/* <button
                        id={`delete_${n?.id}`}
                        className="delete-single-btn"
                        onClick={(e) => {
                          e.stopPropagation(); // ❗ prevent navigation
                          // handleDeleteNotification(n.id);
                        }}
                        title="Delete notification"
                      >
                        ❌
                      </button> */}
                  </div>
                ))
              )}
              {fetchingMore && (
                <div className="notification-loader">
                  <div className="skeleton-item">
                    <div className="skeleton-title" />
                    <div className="skeleton-line" />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      {showModal && (
        <Modal
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showModal}
          onHide={() => setShowModal(false)}
        >
          <Modal.Header closeButton className="border-bottom-0 pb-0">
            <h4 className="font-24 ">Logout?</h4>
          </Modal.Header>

          <Modal.Body className="pt-0">
            <div className="mb-4 text-center">
              {/* <h4 className="font-24 ">Logout?</h4> */}
              <p className="mb-0">Are you sure you want to logout?</p>
            </div>
            <div className="text-center">
              <Button
                variant="secondary me-3 px-5"
                onClick={() => {
                  setShowModal(false);
                }}
              >
                No
              </Button>
              <Button
                variant="danger px-3 p-2"
                style={{ width: "117px" }}
                id="deleteBtnModal"
                onClick={() => {}}
              >
                Yes
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default NotificationBell;
